import { Agreement, AgreementType } from '@varo/graphql-schema-types';
import { toTitleCase } from 'shared/utils/string/string.helpers';

export function titleCaseCityStateZip(str: string) {
  if (str && str !== ' ' && str.includes(',')) {
    const cityAndState = str.split(',');
    const stateAndZip = cityAndState[1].split(' ');
    const city = cityAndState[0];
    const state = stateAndZip[1].toUpperCase();
    const zip = stateAndZip[2];
    return `${toTitleCase(city)}, ${state} ${zip}`;
  }
  return null;
}

export function getBelieveAgreement(agreements: Agreement[]) {
  return agreements.find(
    (agreement) => agreement.type === AgreementType.ChargeCardAgreement,
  );
}

export const formatFullAddress = (
  addressLine1: string | null,
  addressLine2: string | null,
  cityStateZip: string | null,
): string => {
  const parts: string[] = [];

  if (addressLine1) {
    parts.push(toTitleCase(addressLine1));
  }

  if (addressLine2) {
    if (parts.length > 0) {
      parts.push(' ');
    }
    parts.push(toTitleCase(addressLine2));
  }

  if (cityStateZip) {
    const formattedCityStateZip = titleCaseCityStateZip(cityStateZip);
    if (formattedCityStateZip) {
      // Add newline before city/state/zip for correct formatting,
      // but only if there are already other address lines present.
      if (parts.length > 0) {
        parts.push('\n');
      }
      parts.push(formattedCityStateZip);
    }
  }

  return parts.join('');
};
